export default __webpack_public_path__ + "static/media/subject-foreign-language.272667b8.webp";